module.exports = __webpack_public_path__ + "93a476bc208aafd60146b80b1daf95bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/kitchen.jpg
// module id = 180
// module chunks = 0